import instance from '@apis/instance';
import { ColorSchemeResponse } from '@models/colorScheme';

class ColorSchemeApi {
    static getColorScheme(): Promise<ColorSchemeResponse> {
        return instance.get('/v0/color-scheme');
    }
}

export default ColorSchemeApi;
